<script>
export default {
  name: "Loader",
};
</script>
<template>
  <div class="loader">
    <div class="plane"></div>
  </div>
</template>
<style lang="scss">
.loader {
  perspective: 120px;

  .plane {
    width: 1.5rem;
    height: 1.5rem;
    background-color: var(--text-color);
    transform: rotate(0);
    animation: flip 1s infinite;
    border-radius: .2rem;
  }
}

@keyframes flip {
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(180deg) rotateX(180deg);
  }
}
</style>